import { useState } from 'react'
import ComplianceDetailDrawer from './ComplianceDetailDrawer'
import ComplianceHeader from './ComplianceHeader'
import ComplianceLegend from './ComplianceLegend'
import { getStandardHours } from './metricDescriptions'
import RegionCard from './RegionCard'
import './styles.css'
import SupplierCard from './SupplierCard'

const CustomComplianceTable = ({
  data,
  expandedRegions,
  expandedSuppliers,
  // expandedMembers,
  // toggleMemberExpansion,
  toggleRegionExpansion,
  toggleSupplierExpansion,
  isCoordinator,
  selectedMonthYear,
  updatedDate,
}) => {
  const [selectedMetric, setSelectedMetric] = useState(null)

  const handleSelectMetric = (metricInfo) => {
    if (
      selectedMetric?.entityId === metricInfo.entityId &&
      selectedMetric?.metricKey === metricInfo.metricKey
    ) {
      setSelectedMetric(null)
    } else {
      setSelectedMetric(metricInfo)
    }
  }

  // HELPER TO CREATE UNIQUE KEYS
  const getSupplierKey = (regionId, supplierId) => `${regionId}-${supplierId}`
  // const getMemberKey = (regionId, supplierId, memberId) =>
  //   `${regionId}-${supplierId}-${memberId}`

  return (
    <>
      <div className="w-100">
        <div className="d-flex flex-column flex-xl-row gap-4 align-items-start">
          {/* MAIN COMPLIANCE LIST */}
          <div className="flex-grow-1 w-100" style={{ minWidth: 0 }}>
            {/* HEADER */}
            <ComplianceHeader data={data} />

            <div>
              {[...(data?.regions || [])]
                .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                .map((region) => {
                  const regionName = region.name || (region.id ? `Region ${region.id}` : 'Region')

                  return (
                    <div key={region.id} className="mb-4">
                      {/* REGION CARD */}
                      <RegionCard
                        region={region}
                        isExpanded={expandedRegions[region.id]}
                        onToggle={() => toggleRegionExpansion(region.id)}
                      />

                      {/* EXPANDED REGION CONTENT */}
                      <div
                        className={`collapsible-content ${expandedRegions[region.id] ? 'collapsible-enter-active' : 'collapsible-enter'}`}
                        style={{
                          maxHeight: expandedRegions[region.id] ? 'none' : '0',
                          opacity: expandedRegions[region.id] ? 1 : 0,
                          transform: expandedRegions[region.id]
                            ? 'translateY(0)'
                            : 'translateY(-10px)',
                          overflow: expandedRegions[region.id] ? 'visible' : 'hidden',
                          transition: expandedRegions[region.id]
                            ? 'opacity 0.3s ease-out, transform 0.3s ease-out'
                            : 'opacity 0.3s ease-in, transform 0.3s ease-in, max-height 0.3s ease-in',
                        }}
                      >
                        {expandedRegions[region.id] && (
                          <div className="ps-3">
                            {[...(region?.suppliers || [])]
                              .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                              .map((supplier) => {
                                const supplierKey = getSupplierKey(region.id, supplier.id)

                                return (
                                  <div key={supplierKey} className="mb-3">
                                    <SupplierCard
                                      supplier={supplier}
                                      supplierKey={supplierKey}
                                      regionId={region.id}
                                      regionName={regionName}
                                      isExpanded={expandedSuppliers[supplierKey]}
                                      onToggle={() =>
                                        toggleSupplierExpansion(supplierKey)
                                      }
                                      selectedMetric={selectedMetric}
                                      onSelectMetric={handleSelectMetric}
                                    // expandedMembers={expandedMembers}
                                    // toggleMemberExpansion={toggleMemberExpansion}
                                    // getMemberKey={getMemberKey}
                                    />
                                  </div>
                                )
                              })}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
            </div>

            {/* FOOTER */}
            <ComplianceLegend isCoordinator={isCoordinator} standardHours={getStandardHours(data)} />
          </div>

          {/* DETAIL DRAWER PANEL */}
          {selectedMetric && (
            <>
              {/* BACKDROP FOR SLIDE-OVER DRAWER */}
              <div
                onClick={() => setSelectedMetric(null)}
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(15, 23, 42, 0.35)',
                  zIndex: 1040,
                  backdropFilter: 'blur(2px)',
                  animation: 'fadeIn 0.2s ease-in-out',
                }}
              />

              {/* DRAWER CONTAINER */}
              <div className="compliance-drawer-wrapper">
                <ComplianceDetailDrawer
                  selectedMetric={selectedMetric}
                  selectedMonthYear={selectedMonthYear}
                  fromDate={data?.from}
                  toDate={data?.to}
                  requireDetailPermission={data?.requireDetailPermission}
                  requireDetailPermissionName={data?.requireDetailPermissionName}
                  requireDetailPermissionUserId={data?.requireDetailPermissionUserId}
                  onClose={() => setSelectedMetric(null)}
                  onSelectMetric={handleSelectMetric}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default CustomComplianceTable
